/* eslint-disable react/prop-types, react/jsx-handler-names */

import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { withStyles } from "@material-ui/core/styles";
import { InputLabel, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import styled from "styled-components";
import ViewOnlyField from "components/Global/Fields/ViewOnlyField";

const styles = theme => ({
  input: {
    display: "flex",
    padding: 0
  },
  label: {
    fontWeight: "bold",
    color: "black"
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
    fontSize: "17px"
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  placeholder: {
    position: "absolute",
    left: 2,
    fontSize: "17px"
  }
});

const NoOptionsMessage = props => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.noOptionsMessage}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

const Control = props => (
  <TextField
    fullWidth
    InputProps={{
      inputComponent,
      inputProps: {
        className: props.selectProps.classes.input,
        inputRef: props.innerRef,
        children: props.children,
        ...props.innerProps
      }
    }}
    {...props.selectProps.textFieldProps}
  />
);

const Option = props => (
  <MenuItem
    buttonRef={props.innerRef}
    selected={props.isFocused}
    component="div"
    style={{
      fontWeight: props.isSelected ? 500 : 400
    }}
    {...props.innerProps}
  >
    {props.children}
  </MenuItem>
);

const Placeholder = props => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.placeholder}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const ValueContainer = props => (
  <div className={props.selectProps.classes.valueContainer}>
    {props.children}
  </div>
);

const components = {
  Control,
  NoOptionsMessage,
  Option,
  Placeholder,
  ValueContainer
};

class TypeAheadDropdown extends React.Component {
  render() {
    const { classes, theme } = this.props;
    const selectedOption = this.props.options.find(option => option.value === this.props.value);
    const optionValue = selectedOption ? selectedOption.label : null;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        transition: "none",
        "& input": {
          font: "inherit"
        }
      }),
      indicatorSeparator: base => ({
        ...base,
        display: "none"
      }),
      container: base => ({
        ...base,
        borderBottom: "none !important",
        fontSize: "17px",
        transition: "none",
        "&:hover": {
          cursor: "pointer",
          transition: "none !important"
        },
        "div::before": {
          borderBottom: "1px solid #2196F3",
          transition: "none !important"
        },
        padding: "0"
      })
    };

    return (
      this.props.shouldShow && (
        <>
          {this.props.label &&
          (<Grid item xs={3}>
            <InputLabel className={this.props.classes.label} htmlFor={this.props.name}>
              {this.props.label}
            </InputLabel>
           </Grid>)}
          <Grid item xs={4}>
            {!this.props.isEditing &&
              <ViewOnlyField value={optionValue} />}

            {this.props.isEditing &&
              <Select
                isClearable
                fullWidth
                name={this.props.name}
                classes={classes}
                styles={selectStyles}
                options={this.props.options}
                components={components}
                onChange={this.props.handleChange}
                placeholder={this.props.placeholder}
                menuPlacement="auto"
                value={this.props.options.find(
                  option => option.value === this.props.value
                )}
              />}

          </Grid>
        </>
      )
    );
  }
}

TypeAheadDropdown.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(TypeAheadDropdown);
